module.exports = __webpack_public_path__ + "img/isa.e3ba673a.png";